// Fond de carte CARTO « light_all ». CARTO exige désormais une clé
// (REACT_APP_MAP_KEY) : sans elle, les tuiles affichent « API KEY REQUIRED »
export const CARTO_TILES_URL = `https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png${
  process.env.REACT_APP_MAP_KEY ? `?key=${process.env.REACT_APP_MAP_KEY}` : ''
}`;
